import { useLocation } from 'react-router';

import type { NavItem } from '@/shared/types';

import { getPortalAppDefinition } from '../constants';
import { parsePathnameSegments } from '../utils/path';

export const useNavItems = (): NavItem[] | undefined => {
  const { pathname } = useLocation();
  const [appSegment] = parsePathnameSegments(pathname);
  return appSegment ? getPortalAppDefinition(appSegment)?.navItems : undefined;
};
